/**
 * CR550: React Query hooks for regions
 */

import { useQuery } from "@tanstack/react-query";
import { fetchRegions, fetchMerchantKeysForRegion } from "@/lib/regions/api";

/** Hook to fetch all enabled regions */
export function useRegions() {
  return useQuery({
    queryKey: ["regions"],
    queryFn: fetchRegions,
    staleTime: 5 * 60_000, // 5 min — regions rarely change
  });
}

/** Hook to fetch merchant_keys in a selected region */
export function useRegionMerchantKeys(regionId: string | null) {
  return useQuery({
    queryKey: ["region-merchant-keys", regionId],
    queryFn: () => fetchMerchantKeysForRegion(regionId!),
    enabled: !!regionId,
    staleTime: 60_000, // 1 min
  });
}
